import { PlaceOrderDualModeAmountInput } from 'components/PlaceOrderDualModeAmountInput'
import { useBaseCurrencyAmountCallback } from 'hooks/spot/useBaseCurrencyAmount'
import { useQuoteCurrencyAmountCallback } from 'hooks/spot/useQuoteCurrencyAmount'
import { useSetAtom } from 'jotai'
import { memo, useCallback } from 'react'
import { useCreateOrderOption, useCurrentSpotSymbol } from 'store/spot/hooks'
import { Ether } from 'types'
import { orderPercentAtom } from '../AmountPercent/atoms'

export const DualModeAmountInput = memo(() => {
  const {
    baseCurrency = '',
    quoteCurrency = '',
    baseMinimumQuantity = 1,
  } = useCurrentSpotSymbol()
  const { limitPrice, baseCurrencyAmount, quoteCurrencyAmount } =
    useCreateOrderOption()

  const { onBaseCurrencyAmountInput } = useBaseCurrencyAmountCallback()

  const { onQuoteCurrencyAmountInput } = useQuoteCurrencyAmountCallback()

  const onChangeBaseAmount = useCallback(
    (amount: Ether) => {
      onBaseCurrencyAmountInput(amount, limitPrice)
    },
    [onBaseCurrencyAmountInput, limitPrice],
  )

  const setPercent = useSetAtom(orderPercentAtom)

  const handleClickMax = useCallback(() => {
    setPercent(100)
  }, [setPercent])

  return (
    <PlaceOrderDualModeAmountInput
      currentBaseAmount={baseCurrencyAmount}
      currentQuoteAmount={quoteCurrencyAmount}
      baseCurrency={baseCurrency}
      quoteCurrency={quoteCurrency}
      minimumIncrement={String(baseMinimumQuantity)}
      onChangeBaseAmount={onChangeBaseAmount}
      onChangeQuoteAmount={onQuoteCurrencyAmountInput}
      onClickMax={handleClickMax}
    />
  )
})
